export const PUBLIC_SUPPLIER_QUERY = '/public/suppliers';
export const INVITE_QUERY = '/invites';
